import { root } from "../config.js";
import icons from "url:../../images/sprite.svg";

export const renderWeaponPage = (name) => {
  const pageHTML = `
        <div class="weapon">
            <div class="weapon-title-wrapper">
                <div class="weapon-edit" title="Редактировать">
                    <svg class="wd-icon more active">
                        <use xlink:href="${icons}#more-vert"></use>
                    </svg>
                    <svg class="wd-icon close">
                        <use xlink:href="${icons}#close"></use>
                    </svg>
                    <div class="weapon-edit-box">
                        <div class="weapon-edit-item add-image-btn">Добавить изображение</div>
                        <div class="weapon-edit-item add-text-btn">Редактировать описание</div>
                    </div>
                </div>
                <h1 class="weapon-title">${name}</h1>
            </div>
            <div class="weapon-content">
                <div class="weapon-gallery-text">
                    <div class="weapon-gallery-arrows">
                        <div class="weapon-gallery-arrow arrow-left">
                            <svg class="wd-icon">
                                <use xlink:href="${icons}#arrow-down"></use>
                            </svg>
                        </div>
                        <div class="weapon-gallery-arrow arrow-right">
                            <svg class="wd-icon">
                                <use xlink:href="${icons}#arrow-down"></use>
                            </svg>
                        </div>
                    </div>
                    <div class="weapon-gallery-box">
                        
                    </div>
                    <div class="weapon-text">
                        <div class="weapon-text-title">Описание</div>
                        <div class="weapon-text-content"></div>
                        <form class="weapon-text-editor">
                            <textarea id="weapon-text"></textarea>
                            <button name="submitbtn" class="save-weapon-text">
                                <svg class="wd-icon">
                                    <use xlink:href="${icons}#save"></use>
                                </svg>
                                Сохранить
                            </button>
                        </form>
                    </div>
                </div>
                <div class="weapon-video-box">
                    <div class="weapon-video-title">Видео</div>
                    <div class="weapon-video-wrap">
                        
                    </div>
                </div>
            </div>
        </div>
    `;
  root.insertAdjacentHTML("beforeend", pageHTML);
};

export const renderUploadImage = (id) => {
  const uploadHTML = `
        <div class="upload-modal">
            <form id="upload-img">
                <div class="upload-style">
                    <div class="upload-text">
                        <svg class="wd-icon">
                            <use xlink:href="${icons}#upload"></use>
                        </svg>
                        Выберите файл
                    </div>
                    <input type="file" name="picture" accept="png, jpg, jpeg, webp" class="upload-input">
                </div>
                <input type="text" name="id" value="${id}" class="upload-id">
                <input type="submit" value="Загрузить" class="primary-btn upload-btn disabled" disabled>
            </form>
        </div>
    `;
  root.insertAdjacentHTML("beforeend", uploadHTML);
};

export const renderWeaponImages = (data) => {
  const galleryContainer = document.querySelector(".weapon-gallery-box");
  let weaponImages = "";
  if (data.length > 0) {
    data.forEach((image) => {
      weaponImages += `
            <div class="weapon-gallery-item">
                <img src="http://guns.rurik.ru${image.path}" id="${image.id}" alt="${image.alt}">
                <div class="delete-image">
                    <svg class="wd-icon">
                        <use xlink:href="${icons}#delete"></use>
                    </svg>
                </div>
            </div>
            `;
    });
  } else {
    weaponImages = `
        <div class="weapon-gallery-item">
            <div class="weapon-empty-img">
                <svg class="wd-icon empty-icon">
                    <use xlink:href="${icons}#images"></use>
                </svg>
                <div class="weapon-empty-text">
                    <svg class="wd-icon">
                        <use xlink:href="${icons}#upload"></use>
                    </svg>
                    Здесь еще нет изображения.<span class="add-image add-image-btn"> Добавить</span></div>
            </div>
        </div>
        `;
  }
  galleryContainer.insertAdjacentHTML("afterbegin", weaponImages);
};

export const rendreWeaponImg = (img) => {
  const galleryContainer = document.querySelector(".weapon-gallery-box");
  let weaponImage = `
    <div class="weapon-gallery-item">
        <img src="http://armament.cigarpro.ru${img.path}" id="${img.id}" alt="${img.alt}">
        <div class="delete-image">
            <svg class="wd-icon">
                <use xlink:href="${icons}#delete"></use>
            </svg>
        </div>
    </div>
    `;
  galleryContainer.insertAdjacentHTML("beforeend", weaponImage);
};

export const renderFile = (url) => {
  const uploadForm = document.querySelector("#upload-img");
  const fileHTML = `
    <div class="display-image">
        <div class="display-image-thumb-container">
            <img src="${url}" class="upload-img-thumb">
        </div>
        <input type="text" name="alt" value="" placeholder="Введите alt" class="display-image-alt-input">
    </div>
    `;
  uploadForm.insertAdjacentHTML("beforeend", fileHTML);
};

export const renderText = (data) => {
  const textContainer = document.querySelector(".weapon-text-content");
  let textHTML = "";
  if (!data.status) {
    textHTML = `
        <div class="weapon-text-empty">
            Здесь еще нет описания. 
            <span class="add-text add-text-btn">Добавить</span>
        </div>
        `;
  } else {
    textHTML = data.article.body;
  }
  textContainer.insertAdjacentHTML("afterbegin", textHTML);
};

export const renderYouTubePlayList = (data) => {
  const weaponVideoPlaylistWrap = document.querySelector(".weapon-video-wrap");
  let videoTemplate = "";

  data
    .map((item) => {
      videoTemplate += `
            <div class="weapon-video-item">
                <img id="${item.id.videoId}" src="${item.snippet.thumbnails.high.url}" alt="snippet" width="480" height="360" class="weapon-video-preview">
                <div class="weapon-video-item__title">${item.snippet.title}</div>
            </div>
        `;
    })
    .join("");
  weaponVideoPlaylistWrap.insertAdjacentHTML("afterbegin", videoTemplate);
};

export const renderYouTubeVideo = (container, video) => {
  const template = `
    <div class="weapon-gallery-item">
        ${video}
    </div>
    `;
  container.insertAdjacentHTML("beforeend", template);
};

export const renderSearchResult = (data) => {
  let resultLinks = "";
  data.forEach((item) => {
    resultLinks += `<a href="/${item.id}" class="search-result-item">${item.name}</a>`;
  });
  return resultLinks;
};
